import Helpers from './helpers';

const OrganizationMedia = {
	form: null,
	// wire everything up
	init({ form }) {
		if (form) {
			this.form = form;
			this.uploadOther = form.dataset?.uploadOther || 'Upload other photo';
			// get all inputs with type upload
			const inputs = form.querySelectorAll('input[type=file]');
			// render previews
			if (inputs.length > 0) {
				inputs.forEach((input) => {
					if (input.defaultValue) {
						const insertNode = input.parentNode;
						Helpers.renderPreview(insertNode, input.defaultValue);

						const uploadBtn = input.parentNode.querySelector('label');
						if (uploadBtn) {
							uploadBtn.innerText = this.uploadOther;
						}
					}
				});
			}
		}
	},
};

export { OrganizationMedia as default };
